"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPinIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var LocationPinIcon16Light_1 = require("./LocationPinIcon16Light");
var LocationPinIcon16Regular_1 = require("./LocationPinIcon16Regular");
var LocationPinIcon16Solid_1 = require("./LocationPinIcon16Solid");
var LocationPinIcon20Light_1 = require("./LocationPinIcon20Light");
var LocationPinIcon20Regular_1 = require("./LocationPinIcon20Regular");
var LocationPinIcon20Solid_1 = require("./LocationPinIcon20Solid");
var LocationPinIcon24Regular_1 = require("./LocationPinIcon24Regular");
var LocationPinIcon24Solid_1 = require("./LocationPinIcon24Solid");
var LocationPinIcon32Regular_1 = require("./LocationPinIcon32Regular");
var LocationPinIcon64Regular_1 = require("./LocationPinIcon64Regular");
var sizes = {
    16: {
        light: LocationPinIcon16Light_1.LocationPinIcon16Light,
        regular: LocationPinIcon16Regular_1.LocationPinIcon16Regular,
        solid: LocationPinIcon16Solid_1.LocationPinIcon16Solid,
    },
    20: {
        light: LocationPinIcon20Light_1.LocationPinIcon20Light,
        regular: LocationPinIcon20Regular_1.LocationPinIcon20Regular,
        solid: LocationPinIcon20Solid_1.LocationPinIcon20Solid,
    },
    24: {
        regular: LocationPinIcon24Regular_1.LocationPinIcon24Regular,
        solid: LocationPinIcon24Solid_1.LocationPinIcon24Solid,
    },
    32: {
        regular: LocationPinIcon32Regular_1.LocationPinIcon32Regular,
    },
    64: {
        regular: LocationPinIcon64Regular_1.LocationPinIcon64Regular,
    },
};
exports.LocationPinIcon = forwardRef_1.forwardRef('LocationPinIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
